const isProduction = process.env.NODE_ENV === "production" &&
  typeof window !== "undefined" && window.location.hostname === "www.primedlandscaping.com";
const validId = (value, prefix) => typeof value === "string" && value.startsWith(prefix) ? value : "";
const GA4_ID = validId(process.env.REACT_APP_GA4_ID, "G-");
const GTM_ID = validId(process.env.REACT_APP_GTM_ID, "GTM-");
const ADS_ID = validId(process.env.REACT_APP_GOOGLE_ADS_ID, "AW-");
const REQUIRE_CONSENT = process.env.REACT_APP_REQUIRE_GOOGLE_CONSENT === "true";

export const initializeGoogleTags = () => {
  if (!isProduction || (!GA4_ID && !GTM_ID && !ADS_ID)) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  if (REQUIRE_CONSENT) {
    window.gtag("consent", "default", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      wait_for_update: 500,
    });
  }
  if (GTM_ID) {
    const gtm = document.createElement("script");
    gtm.async = true;
    gtm.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(GTM_ID)}`;
    document.head.appendChild(gtm);
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    return;
  }
  const ids = [GA4_ID, ADS_ID].filter(Boolean);
  const loader = document.createElement("script");
  loader.async = true;
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ids[0])}`;
  document.head.appendChild(loader);
  window.gtag("js", new Date());
  ids.forEach((id) => window.gtag("config", id));
};

export const trackEvent = (eventName, parameters = {}) => {
  if (isProduction && typeof window.gtag === "function") window.gtag("event", eventName, parameters);
};

export const updateGoogleConsent = (granted) => {
  if (typeof window.gtag !== "function") return;
  const value = granted ? "granted" : "denied";
  window.gtag("consent", "update", {
    analytics_storage: value,
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  });
};

export const installConversionTracking = () => {
  const handler = (event) => {
    const link = event.target.closest?.("a[href]");
    if (!link) return;
    const href = link.getAttribute("href") || "";
    if (href.startsWith("tel:")) trackEvent("phone_click", { link_location: window.location.pathname });
    if (href.startsWith("mailto:")) trackEvent("email_click", { link_location: window.location.pathname });
    if (link.hasAttribute("download")) trackEvent("file_download", { file_name: href.split("/").pop() });
  };
  document.addEventListener("click", handler);
  return () => document.removeEventListener("click", handler);
};
